module.exports = __webpack_public_path__ + "img/absolut-reg-bg.466a4e2b.jpg";